/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IProcessDataSectionScope extends ng.IScope {
        isConfigureMode: boolean;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        manageSection: Wars.Domain.Model.ManageSection;
        processConfigurationId: string;
        save: any;
        getValue: (item: Wars.Domain.Model.ProcessDataViewConfiguration) => string;
        viewHistory: (item: Wars.Domain.Model.ProcessDataViewConfiguration, rowId?: string) => void;
        getListValues: (item: Wars.Domain.Model.ProcessDataViewConfiguration) => any;
        getListValue: (item: Wars.Domain.Model.ProcessDataViewConfiguration, rowId: string) => string;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
    }

    export class ProcessDataSection implements IDirective {
        public link($scope: IStatusHistoryScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/manageForm/processDataSection.html';
        public controller = [
            '$scope', 'manageProcessDataConfigurationService', 'objectSchemaService', 'processConfigurationService',
            'ModalService', 'variableTypeService', "processDocumentService", ProcessDataSectionController];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            manageSection: "=",
            process: "=",
            processConfigurationId: "=",
            processConfiguration: "="
        };
    }

    export class ProcessDataSectionController {
        private processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        private objectSchema: Wars.Domain.Model.ObjectSchema;

        constructor(
            private $scope: IProcessDataSectionScope,
            private manageProcessDataConfigurationService: services.ManageProcessDataConfigurationService,
            private objectSchemaService: services.ObjectSchemaService,
            private processConfigurationService: services.ProcessConfigurationService,
            private modalService: any,
            private variableTypeService: services.VariableTypeService,
            private processDocumentService: services.ProcessDocumentService)
        {
            $scope.save = () => this.save();
            $scope.getValue = (item: Wars.Domain.Model.ProcessDataViewConfiguration) => this.getValue(item);
            $scope.getListValues = (item: Wars.Domain.Model.ProcessDataViewConfiguration) => this.getListValues(item);
            $scope.getListValue = (item: Wars.Domain.Model.ProcessDataViewConfiguration, rowId: string) => this.getListValue(item, rowId);
            $scope.viewHistory = (item: Wars.Domain.Model.ProcessDataViewConfiguration, rowId?: string) => this.viewHistory(item, rowId);

            if ($scope.isConfigureMode) {

                if ($scope.processConfiguration.processDataSchema_id) {
                    this.objectSchemaService.getObjectSchemaExpanded($scope.processConfiguration.processDataSchema_id).then(
                        (objectSchema) => {
                            this.objectSchema = objectSchema;

                            var propsToAdd = Enumerable.from(objectSchema.properties)
                                .where(p => !Enumerable.from(this.$scope.manageSection.manageProcessDataConfiguration.processDataViewConfigurations)
                                    .any(prop => prop.schemaProperty_id === p.id ||
                                        (!p.typeSchema || !Enumerable.from(p.typeSchema.properties).any(tp=>tp.id === prop.id)))).toArray();

                            propsToAdd.forEach(prop => {
                                if (prop.typeSchema !== null) {
                                    prop.typeSchema.properties.forEach(listProperty => {
                                        this.addSchemaProperty(listProperty, prop.name + " - " + listProperty.name, true);
                                    });
                                } else {
                                    this.addSchemaProperty(prop, prop.name, false);
                                }
                            });

                            var configsToRemove = Enumerable.from(this.$scope.manageSection.manageProcessDataConfiguration.processDataViewConfigurations)
                                .where(p => !Enumerable.from(objectSchema.properties).any(prop => prop.id === p.schemaProperty_id ||
                                    (!prop.typeSchema || !Enumerable.from(prop.typeSchema.properties).any(tp=>tp.id === p.id)))).toArray();

                            configsToRemove.forEach(c => {
                                c.entityAspect.setDeleted();
                            });

                            this.save();
                        });
                }
            }
        }

        private addSchemaProperty(schemaProperty: Wars.Domain.Model.SchemaProperty, name: string, isList: boolean): void {
            let newViewConfig = this.manageProcessDataConfigurationService.createProcessDataViewConfiguration();
            newViewConfig.showHistory = this.$scope.manageSection.manageProcessDataConfiguration.showHistory;
            newViewConfig.show = false;
            newViewConfig.schemaProperty_id = schemaProperty.id;
            newViewConfig.name = name;
            newViewConfig.isList = isList;
            this.$scope.manageSection.manageProcessDataConfiguration.processDataViewConfigurations.push(newViewConfig);
        }

        private getValue(item: Wars.Domain.Model.ProcessDataViewConfiguration): any {
            var property = this.getSchemaProperty(item);
            if (!property) return "";

            var value = this.$scope.process.processData[property.uniqueIdentifier];

            if (property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Document) {
                return this.processDocumentService.getDocumentById(this.$scope.process, value);
            } else {
                let returnValue = this.variableTypeService.format(value, item.schemaProperty.propertyType);
                return returnValue;
            }
        }

        private getListValues(item: Wars.Domain.Model.ProcessDataViewConfiguration): any {
            var property = this.getSchemaProperty(item);
            if (!property) return [];

            if (!this.$scope.process || !this.$scope.process.processData) return [];
            var rows = this.$scope.process.processData[property.typeSchema.uniqueIdentifier];
            return rows;
        }

        private getListValue(item: Wars.Domain.Model.ProcessDataViewConfiguration, rowId: string): any {
            var topLevelSchemaProperty = this.getSchemaProperty(item);
            if (!topLevelSchemaProperty) return "";

            var listItemSchemaProperty = Enumerable.from(topLevelSchemaProperty.typeSchema.properties).singleOrDefault(i => i.id === item.schemaProperty_id);
            if (!listItemSchemaProperty) return "";

            var rowObjects : any[] = this.$scope.process.processData[topLevelSchemaProperty.typeSchema.uniqueIdentifier];
            if (!rowObjects) return "";
            var rowObject = Enumerable.from(rowObjects).singleOrDefault(i => i.id === rowId);
            if (!rowObject) return "";
            var value = rowObject[listItemSchemaProperty.uniqueIdentifier];

            if (listItemSchemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Document) {
                return this.processDocumentService.getDocumentById(this.$scope.process, value);
            } else {
                let returnValue = this.variableTypeService.format(value, item.schemaProperty.propertyType);
                return returnValue;
            }
        }

        private getSchemaProperty(item: Wars.Domain.Model.ProcessDataViewConfiguration): Wars.Domain.Model.SchemaProperty {
            if (!this.$scope.processConfiguration || !this.$scope.processConfiguration.processDataSchema) return undefined;
            return item.isList ? this.getTopLevelListSchemaProperty(item.schemaProperty_id) : this.getNonListSchemaPropertyById(item.schemaProperty_id);
        }

        private getNonListSchemaPropertyById(id: string): Wars.Domain.Model.SchemaProperty {
            return Enumerable.from(this.$scope.processConfiguration.processDataSchema.properties).singleOrDefault(p => p.id === id);
        }

        private getTopLevelListSchemaProperty(listItemSchemaPropertyId: string): Wars.Domain.Model.SchemaProperty {
            for (var topLevelIndex = 0; topLevelIndex < this.$scope.processConfiguration.processDataSchema.properties.length; topLevelIndex++) {
                var currentTopLevelSchemaProperty = this.$scope.processConfiguration.processDataSchema.properties[topLevelIndex];
                if (currentTopLevelSchemaProperty.typeSchema) {
                    for (var i = 0; i < currentTopLevelSchemaProperty.typeSchema.properties.length; i++) {
                        if (currentTopLevelSchemaProperty.typeSchema.properties[i].id === listItemSchemaPropertyId) {
                            return currentTopLevelSchemaProperty;
                        }
                    }
                }
            }
            return undefined;
        }

        private viewHistory(item: Wars.Domain.Model.ProcessDataViewConfiguration, rowId?: string): void {
            this.modalService.showModal({
                templateUrl: "./app/views/modals/historyModal.html",
                controller: "historyModalController",
                size: 'lg',
                inputs: {
                    process: this.$scope.process,
                    processConfigId: this.$scope.processConfigurationId,
                    uniqueId: item.schemaProperty.parentObjectSchema.isList
                        ? item.schemaProperty.parentObjectSchema.uniqueIdentifier
                        : item.schemaProperty.uniqueIdentifier,
                    formDataId: null,
                    propertyId: item.schemaProperty.parentObjectSchema.isList
                        ? item.schemaProperty.uniqueIdentifier
                        : undefined,
                    codeGroupId: item.schemaProperty.codeGroup_id,
                    rowId: rowId
                }
            }).then(modal => {
                modal.element.modal();
                modal.close.then(result => {
                    $(".modal-backdrop").each(function() {
                        $(this).remove();
                    });
                });
            });
        }

        private save() {
            this.manageProcessDataConfigurationService.saveAllChanges();
        }
    }
}
warsApp.registerDirective('ProcessDataSection', []);